import i18n from 'i18n';
import { ConditioningType, Material } from 'types';

export const raDateValidation = (value: any) => {
  if (value) {
    let date = new Date(value);

    if (isNaN(date.getTime())) {
      return i18n.t('components.datePicker.invalidDateMessage');
    }

    const maxDate = new Date('01/01/2100');

    if (date > maxDate) {
      return i18n.t('components.datePicker.tooFarDateMessage');
    }
  }
  return;
};

export const isMaterialBulk = (material: Material | undefined): boolean =>
  ConditioningType.Bulk === material?.conditioningType;

export const isMaterialConditionnedInBalls = (material: Material | undefined): boolean =>
  !!material && [ConditioningType.Ball, ConditioningType.Package].includes(material.conditioningType);
